import { getArgs } from "../utils";
import api from "./api";
const route = "/conversations";

const ConversationsService = {
  getAllTags: (filters) => api.get(`${route}/tags?${getArgs(filters)}`),
  getConversations: (filters) => api.get(`${route}?${getArgs(filters)}`),
  getSingleConversations: (conversation_id) =>
    api.get(`${route}/conversation/${conversation_id}`),
  postConversation: (conversation) => api.post(route, { ...conversation }),
  postConversationFile: (formData, conversation_id) => {
    return api.post(
      `${route}/file/${conversation_id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
  putConversation: (conversation) => api.put(route, { ...conversation }),
  deleteConversation: (conversation_id) =>
    api.delete(`${route}/${conversation_id}`),
};
export default ConversationsService;
